// extracted by mini-css-extract-plugin
export default {"back-button":"back-button___wlitWL9t"};